import { isReauthRequiredError } from '@features/auth/session/model/reauth';
import {
  sessionStore,
  startSessionWatcher,
} from '@features/auth/session/model/store.svelte';
import { registerReauthPredicate } from '@shared/api/client';

/// ADR (architecture-decision-record_1.md L356) 規約「app/ = Auth0 初期化」
/// を満たすための薄いエントリポイント。 実体は features/auth/session の
/// `sessionStore.initialize()` に集約しており、 ここはアプリ起動シーケンス上の
/// 配線フックでしかない。
///
/// `startSessionWatcher()` の購読配線も app 層に置く (router の `startRouter()`
/// を main.ts で配線するのと同じ流儀)。 token 透過更新失敗時の再ログインを
/// `initialize()` 前に有効化しておく。
///
/// あわせて、 token 取得失敗を「再認証で解決するか」 判定する predicate を
/// `shared/api/client` に注入する。 判断ロジック (`isReauthRequiredError`) の
/// 所有権は features 層にあり、 shared は注入された predicate を呼ぶだけ
/// (FSD: shared は判断を持たずイベント発行のみ)。
///
/// `initialize()` 完了後 (= 認証確立後)、ADR 20260528 §7 の JIT 同期を 1 回発火する。
/// `initialize()` は未認証なら loginWithRedirect で pending のまま戻らないため、ここに
/// 到達するのは認証済みケース。`sync()` は失敗してもアプリ起動を妨げない設計
/// (401 は内部で強制ログアウト)。
export async function bootstrapAuth(): Promise<void> {
  registerReauthPredicate(isReauthRequiredError);
  startSessionWatcher();
  await sessionStore.initialize();
  if (sessionStore.isAuthenticated) {
    await sessionStore.sync();
  }
}
